import React from 'react'
import { formatSIWithIntegerThreshold } from '../lib/format-utils'

interface Props {
  emissions: number
  classNames?: string
}

function formatLulucf(value: number) {
  return Math.abs(value) >= 0.01
    ? formatSIWithIntegerThreshold(value, { digitsThreshold: 2 })
    : value.toLocaleString('us-US', { minimumSignificantDigits: 1, maximumSignificantDigits: 1 })
}

export const LulucfCaption: React.FC<Props> = ({ emissions, classNames }) => {
  return (
    <div className={`${classNames} flex-ns tc f6`}>
      <div>
        *{emissions > 0 ? 'includes' : 'does not include'}{' '}
        <span className="b">
          {formatLulucf(emissions)} mmt CO<sub>2 </sub>
        </span>
        &nbsp;
      </div>
      <div>{emissions > 0 ? 'from' : 'absorbed by'} Land use and Forestry</div>
    </div>
  )
}
